<template>
  <div class="template-basicPage">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="openingParagraph">
            <h2 style="margin-bottom: 5px !important;">You are on {{ browser }} {{ browserVersion }} using {{ operatingSystem }}</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const Bowser = require("bowser");
const currentBrowser = Bowser.getParser(window.navigator.userAgent);

export default {
  name: "Browser",
  title: "Browser",
  data: () => ({
    browser: "",
    browserVersion: "",
    operatingSystem: "",
  }),
  created: function () {
    this.browser = currentBrowser.getBrowserName()
    this.browserVersion = currentBrowser.getBrowserVersion()
    this.operatingSystem = currentBrowser.getOSName()
  },
};
</script>


<style lang="scss" scoped>
@import "@/assets/sass/pageTemplates/basicPage.scss";
.template-basicPage{
  margin-bottom: 90px;

  p{
    color: $color4;
    line-height: 32px;
  }
}
</style>

<style lang="scss">
@media (min-width: 768px){
  .template-footer{
    position: fixed;
    bottom: 0;
    width: 100vw;
  }
}
</style>
